import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const inr = (v) => {
  const n = Number(v || 0);
  if (n >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (n >= 1e5) return `₹${(n / 1e5).toFixed(2)} Lakh`;
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
};

export const num = (v) => Number(v || 0).toLocaleString("en-IN");

export const critTone = (c) =>
  c === "A"
    ? "bg-rose-500/15 text-rose-500 border-rose-500/30"
    : c === "B"
    ? "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30"
    : "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30";

export const actionTone = (a) =>
  a === "reduce"
    ? "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30"
    : a === "increase"
    ? "bg-rose-500/15 text-rose-500 border-rose-500/30"
    : "bg-slate-500/15 text-slate-500 dark:text-slate-300 border-slate-500/30";
